export default "__VITE_ASSET__DQmEx_D___"